import { render } from "./HomeProf.vue?vue&type=template&id=22ae969d"
import script from "./HomeProf.vue?vue&type=script&lang=js"
export * from "./HomeProf.vue?vue&type=script&lang=js"

import "./HomeProf.vue?vue&type=style&index=0&id=22ae969d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__